<template>
 <div >
    <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3 mb-5">
          <div class="footer__title">İLETİŞİM</div>
          <div class="footer__item">
            <i class="fas fa-map-marker-alt icon"></i>
            <a href="https://www.google.com/maps/place/Balat,+Manyasizade+%C3%87k.+No:7,+34087+
                    Fatih%2F%C4%B0stanbul/@41.0269506,28.9454087,17z/data=!3m1!4b1!4m5!3m4!1s0x14caba1c0db2e8af:
                    0x140e6956be67683e!8m2!3d41.0269506!4d28.9475974" target="_blank">
              Balat Mah. Manyasızade Cd.
              <br />Manyasızade Çk. No:7/3-B
              <br />Fatih, 34087 İstanbul
            </a>
          </div>
          <div class="footer__item">
            <i class="fas fa-envelope icon"></i>
            <a href="mailto:bilgi@ismailagadernegi.org.tr" target="_top">E Posta Gönder</a>
          </div>

          <div class="footer__item">
            <i class="fas fa-phone icon"></i>
            <a href="tel:0850 811 77 77">0850 811 7777</a>
          </div>
        </div>
        <div class="col-md-3 mb-5" v-for="link in links" :key="link.id">
          <div class="footer__title">{{link.text.toLocaleUpperCase('tr')}}</div>
          <div class="footer__item" v-for="child in link.children" :key="child.id">
            <a :href="child.url">
              {{child.text}}
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="footer__social--wrapper">
      <div class="container">
        <div class="row justify-content-between align-items-center">
        <div class="col-md-6">
          <div class="footer__desc">
            <p>© 2019 İsmailağa Derneği | Her Hakkı Saklıdır.</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="footer__social">
            <a href="https://www.instagram.com/ismailaga.cami/" target="_blank">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://twitter.com/ismailaga_cami" target="_blank">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.facebook.com/ismailaga.cami" target="_blank">
              <i class="fab fa-facebook"></i>
            </a>
            <a href="https://ismailagacami.tumblr.com/" target="_blank">
              <i class="fab fa-tumblr"></i>
            </a>
            <a href="https://tr.pinterest.com/ismailagacami/" target="_blank">
              <i class="fab fa-pinterest"></i>
            </a>
            <a href="https://www.youtube.com/user/ismailagakurumsal" target="_blank">
              <i class="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>
      </div>
    </div>
 </div>
</template>

<script>
export default {
  data() {
    return {
      links: []
    }
  },
  created() {
    this.$http.get('menu/footer').then((res) => {
      this.links = res.data.data.menu_objects
    })
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.192)),
    url("../assets/img/footer_bg.jpg");
  background-repeat: no-repeat;
}
</style>
